import { DateRangePicker, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import dayjs from 'dayjs';
import CustomRangeShortcuts from './CustomRangeShortcuts';
import { $$splPage } from './model';
import { FormErrors, SplFormByName } from './types';
import { shortcutsItems } from './utils';
import { useUnit } from 'effector-react';
import { $$theme } from '../../services/ThemeService/model.ts';

type SplDateRangePickerProps = {
  formData: Partial<SplFormByName>;
  errors: FormErrors;
};

export default function SplDateRangePicker(props: SplDateRangePickerProps) {
  const { palette } = useUnit($$theme.$palette);
  const { formData, errors } = props;
  const localeTextConfig = { start: 'Start Date', end: 'End Date' };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateRangePicker
        value={[dayjs((formData as SplFormByName).startDate), dayjs((formData as SplFormByName).endDate)]}
        onChange={newValue =>
          $$splPage.setFormData({
            startDate: newValue[0]?.format('MM/DD/YYYY') || '',
            endDate: newValue[1]?.format('MM/DD/YYYY') || ''
          })
        }
        slots={{ shortcuts: CustomRangeShortcuts }}
        slotProps={{
          shortcuts: { items: shortcutsItems },
          toolbar: { hidden: true },
          actionBar: { hidden: true },
          field: { dateSeparator: '' },
          textField: ({ position }) => {
            const labelText = position === 'start' ? localeTextConfig.start : localeTextConfig.end;

            const customLabel = (
              <span>
                {labelText}{' '}
                <sup style={{ color: palette.error.main, fontSize: '1em' }} aria-label="This is a required field">
                  *
                </sup>
              </span>
            );

            if (position === 'start') {
              return { error: Boolean(errors.startDate), sx: { maxWidth: 275 }, label: customLabel };
            }
            if (position === 'end') {
              return { error: Boolean(errors.endDate), sx: { maxWidth: 275 }, label: customLabel };
            }
            return {};
          }
        }}
        calendars={2}
        sx={{ '> *': { marginLeft: '0px !important' }, gap: 1, width: '100%', display: 'flex', flex: 2 }}
      />
    </LocalizationProvider>
  );
}
